import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import InternalPayslipesTable from "./InternalPayslipesTable"
import { useTranslation } from "react-i18next"

export default function InternalPayslipesList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Internal Payslipes")} />
        <InternalPayslipesTable />
      </div>
    </div>
  )
}
